import groq from 'groq';

import { ASSET } from '../common';

export const TIMELINE = groq`
  title,
  years[] {
    year,
    events[] {
      category,
      title,
      image {
        ${ASSET}
      },
      link
    }
  }
`;

export const TIMELINE_BLOCK = groq`
  _type == 'timeline_companyTimeline' => {
    ${TIMELINE}
  }
`;
